// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
// 引入element UI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
// 引入路由
import router from "./router";
// 引入状态管理
import store from "./vuex/store";
// 引入icon
import "./assets/icon/iconfont.css";

import locale from "element-ui/lib/locale";
locale.i18n((key, value) => i18n.t(key, value));
//

import axios from "axios";
Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

// 使用element UI

import i18n from "./i18n"; // Internationalization

Vue.use(ElementUI, {
  size: "medium", // set element-ui default size设置元素默认大小
  i18n: (key, value) => i18n.t(key, value), // 在注册Element时设置i18n的处理方法
});

/* eslint-disable no-new */
window.vm = new Vue({
  el: "#app",
  router,
  store, //使用store vuex状态管理
  components: { App },
  template: "<App/>",
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue(),
  },
  i18n,
});



// WEBPACK FOOTER //
// ./src/main.js